
import React, { useState } from "react";
import AIChatMessage from "./AIChatMessage";
import { sendAIMessage } from "../../services/aiAssistantService";
import "./AIChatPanel.css";

export default function AIChatPanel({ onClose }) {
  const [messages, setMessages] = useState([
    {
      role: "assistant",
      content:
        "Hello! I'm your AI Business Assistant. I can help you explore projects, candidates, workflows, and business information as integrations become available.",
    },
  ]);

  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [conversationId, setConversationId] = useState(null);
  const [error, setError] = useState("");

  async function handleSubmit(event) {
    event.preventDefault();

    const question = input.trim();

    if (!question || loading) return;

    setInput("");
    setError("");

    setMessages((previous) => [
      ...previous,
      { role: "user", content: question },
    ]);

    setLoading(true);

    try {
      const result = await sendAIMessage(question, conversationId);

      if (result.conversation_id) {
        setConversationId(result.conversation_id);
      }

      setMessages((previous) => [
        ...previous,
        {
          role: "assistant",
          content:
            result.answer || "The AI service returned no answer.",
        },
      ]);
    } catch (err) {
      setError(
        "Unable to contact the AI service. Check that the backend is running."
      );
      console.error("AI assistant error:", err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <section
      className="ai-chat-panel"
      role="dialog"
      aria-label="AI Business Assistant"
    >
      <header className="ai-chat-header">
        <div>
          <div className="ai-chat-title">AI Business Assistant</div>
          <div className="ai-chat-subtitle">
            Your Qualion workspace assistant
          </div>
        </div>

        <button
          type="button"
          className="ai-chat-close"
          onClick={onClose}
          aria-label="Close assistant"
        >
          ×
        </button>
      </header>

      <div className="ai-chat-messages" aria-live="polite">
        {messages.map((message, index) => (
          <AIChatMessage
            key={`${index}-${message.role}`}
            message={message}
          />
        ))}

        {loading && (
          <div className="ai-chat-loading">
            AI Assistant is thinking...
          </div>
        )}

        {error && (
          <div className="ai-chat-error" role="alert">
            {error}
          </div>
        )}
      </div>

      <form className="ai-chat-form" onSubmit={handleSubmit}>
        <textarea
          value={input}
          onChange={(event) => setInput(event.target.value)}
          placeholder="Ask about your workspace..."
          aria-label="Message AI assistant"
          rows={2}
          disabled={loading}
        />

        <button
          type="submit"
          disabled={loading || !input.trim()}
        >
          {loading ? "Sending..." : "Send"}
        </button>
      </form>

      <footer className="ai-chat-footer">
        AI responses can be incorrect. Verify important information.
      </footer>
    </section>
  );
}
